const Dots = (props) => {

    const { isMobile, mixes, activeIndex } = props;
  return (
    <div
      className={`home__pagination-wrapper ${mixes[activeIndex]._type === 'editorsLetter' ? 'opacity':''}`}>
      {mixes.map((item, index) => {
        const angle = (index / (mixes.length )) * 360;
        return (
          <div
            key={`dot${index}`}
            className={`home__pagination-dot ${index === activeIndex? 'active':''}`}
            style={{
              transform: `rotate(${angle}deg) translateY(calc(${isMobile? '10vw':'10vh'} - 2.5px))`,
            }}
          />
        );
      })}
    </div>
  )
}

export default Dots